import React from 'react'
import '../dist/css/Disclaimer.css'

function Disclaimer() {
  return (
    <React.Fragment>
        
        <div className='disclaimer'>
            <a href='/disclaimer'>Learn more about this project <img src="https://assets-global.website-files.com/6257adef93867e50d84d30e2/6322e780df6ee24d4d83321f_ArrowButton.svg"></img></a>
        </div>

    </React.Fragment>
  )
}

export default Disclaimer